import fields from './fields';
import validations from './validations';

export default {
    fields,
    validations,
};
